    import React, { ReactNode } from "react";
    import {
        Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
        TableFooter,
        Typography,
        Box,
        Pagination,
        Stack
    } from '@mui/material';
    import { useTranslation } from "react-i18next";

    export interface IFooterData {
        showingQuantity: number;
        dataType: string;
        totalQuantity: number;
    }

    interface IGenericTable {
        headers: string[];
        bodyData: ReactNode;
        footerData?: IFooterData;
        currentPage?: number;
        onPageChange?: (page: number) => void;
        dataPerPage?: number;
        isGroupPage?: boolean;
    }

    export const GenericTable: React.FC<IGenericTable> = ({
        headers,
        bodyData,
        footerData,
        currentPage = 1, 
        onPageChange,
        dataPerPage = 10, 
        isGroupPage
    }) => {

        const { t } = useTranslation();

        const totalQuantity = footerData?.totalQuantity || 0;
        const showingQuantity = footerData?.showingQuantity || 0;

        const totalPages = Math.ceil(totalQuantity / (dataPerPage || 1));

        return (
            <TableContainer
                component={Paper}
                sx={{
                    border: '1px solid #EAEAEA',
                    borderRadius: '4px',
                    boxShadow: 'none',
                    overflowX: "unset"
                }}
            >
                <Table>
                    <TableHead
                        sx={{
                            height: '36px',
                            '& .MuiTableCell-root': {
                                padding: '8px',
                                font: 'normal normal 600 14px/21px Segoe UI',
                                color: '#818181'
                            }
                        }}
                    >
                        <TableRow>
                            <TableCell sx={{ padding: '0px', width: '30px' }}> </TableCell>
                            {headers.map((h, index, list) => (
                                <TableCell sx={index == list.length - 1 ? { textAlign: "start" } : {}} key={index}>{h}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {bodyData}
                    </TableBody>
                </Table>
                {!isGroupPage && footerData && (
                    <TableFooter sx={{ position: "relative", padding: "16px", display: "flex", alignItems: "center" }}>
                        <Typography sx={{ textAlign: "left", display: "flex" }}>
                            {t("AdminConsole.Showing")}
                            <Typography sx={{ fontWeight: 'bold', padding: '0 4px' }}>{showingQuantity}</Typography>
                            {footerData.dataType} {t("AdminConsole.Of")}
                            <Typography sx={{ fontWeight: 'bold', padding: '0 4px' }}>{totalQuantity}</Typography>
                            {t("AdminConsole.Total")}
                        </Typography>
                        <Box sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
                            <Stack spacing={2}>
                                <Pagination
                                    count={totalPages}
                                    page={currentPage}
                                    onChange={(event, page) => onPageChange ? onPageChange(page) : null}
                                    sx={{
                                        '& .Mui-selected': {
                                            backgroundColor: '#E8EFF3',
                                            color: '#22638D',
                                        },
                                    }}
                                />
                            </Stack>
                        </Box>
                    </TableFooter>
                )}
            </TableContainer>
        );
    };
